/**
 * Hotspot Configuration
 *
 * Defines the supported geographic areas ("hotspots") for the application.
 * Users outside these areas will see a warning banner indicating that
 * listings may be sparse in their region.
 *
 * To add a new hotspot, simply add a new entry to the HOTSPOTS array.
 */

export interface Hotspot {
    /** Display name for the hotspot area */
    name: string;
    /** Center latitude of the hotspot */
    latitude: number;
    /** Center longitude of the hotspot */
    longitude: number;
    /** Radius of the hotspot area in kilometers */
    radiusKm: number;
}

export const HOTSPOTS: Hotspot[] = [
    {
        name: "Marathalli",
        latitude: 12.956923999999999,
        longitude: 77.701127,
        radiusKm: 5,
    },
    // Add more hotspot areas here as needed
];
